class ConstructorTracking {
  constructor(context) {
    this.node =
      context.container?.querySelector('[data-cnstrc-product-detail]') ||
      document.querySelector('[data-cnstrc-product-detail]');
    this.cta = this.node.querySelector('button[type="submit"]');
    this.isValidCta = context?.isValidCta || false;
  }

  /**
   * Validate variant id prevent invalid values
   * @param {string} id - variant id
   * @returns {string} - validated id
   */
  #validateId(id) {
    return id.match(/^\d+$/) ? id : '';
  }

  /**
   * Update Constructor variation data attributes
   * @param {Object} variant - variant object
   * @returns {void} - nothing
   */
  updateVariation(variant = null) {
    if (!this.node) return;
    // Get a valid variant id data from argument or the DOM
    const variantId = variant?.id.toString() || this.node.querySelector('form input[name="id"]')?.value || '';
    const variantPrice =
      this.node.querySelector('.pdp-c-atc-size-selector__size-item--active')?.dataset.price || variant?.price || '';

    // Set attributes
    this.node.setAttribute('data-cnstrc-item-variation-id', this.#validateId(variantId));
    this.isValidCta && this.node.setAttribute('data-cnstrc-item-price', (Number(variantPrice) / 100).toFixed(2)); // set it as float with 2 decimals. i.e. 25.00

    // Set CTA attribute
    this.isValidCta && this.#updateCallToAction(variant);
  }

  /**
   * Update Constructor CTA data attribute
   * @param {Object} variant - variant object
   * @returns {void} - nothing
   */
  #updateCallToAction(variant = null) {
    if (!this.cta) return;

    const activeSize = this.node.querySelector('.pdp-c-atc-size-selector__size-item--active');
    let ctaText = activeSize?.dataset.availability === 'true' ? 'add_to_cart' : 'add_to_wishlist';
    if (!activeSize) {
      ctaText = variant?.available ? 'add_to_cart' : 'add_to_wishlist';
    }
    // Update CTA data attribute
    this.cta.setAttribute('data-cnstrc-btn', ctaText);
  }

  /**
   * Validate if the instance was created for the specific container
   * @param {HTMLDivElement} container - container element where should be constructor data attributes
   * @returns {boolean} - validation result
   */
  validateObj(container) {
    return container?.querySelector('[data-cnstrc-product-detail]') === this.node;
  }
}

export default ConstructorTracking;
